import {
	SERVER_GET_MELDOO_WEB_REPORTS,
	SERVER_GET_MELDOO_WEB_REPORT_DETAILS,
	SERVER_GET_MELDOO_WEB_SEARCH_RESULTS,
	SERVER_GET_MELDOO_WEB_SETTINGS,
	SERVER_GET_MELDOO_WEB_CAPTCHA,
	SERVER_SEND_NEW_MELDOO_WEB_REPORT,
	RESET_SEND_NEW_MELDOO_WEB_REPORT_RESPONSE,
	SERVER_GET_MELDOO_WEB_TYPES_BY_LOCATION,
	SERVER_GET_MELDOO_WEB_TYPES_BY_ORGANISATIONKEY
} from 'constants/ActionTypes';

export const getMeldooWebReports = organisationKey => {
	return { type: SERVER_GET_MELDOO_WEB_REPORTS, payload: { organisationKey } };
};

export const getMeldooWebReportDetails = reportId => {
	return { type: SERVER_GET_MELDOO_WEB_REPORT_DETAILS, payload: { reportId } };
};

export const getMeldooWebSearchResults = (organisationKey, searchParameter) => {
	return { type: SERVER_GET_MELDOO_WEB_SEARCH_RESULTS, payload: { organisationKey, searchParameter } };
};

export const getMeldooWebSettings = organisationKey => {
	return { type: SERVER_GET_MELDOO_WEB_SETTINGS, payload: { organisationKey } };
};

export const getMeldooWebCaptcha = organisationKey => {
	return { type: SERVER_GET_MELDOO_WEB_CAPTCHA, payload: { organisationKey } };
};

export const sendNewMeldooWebReport = (organisationKey, reportData, captchaValue) => {
	return { type: SERVER_SEND_NEW_MELDOO_WEB_REPORT, payload: { organisationKey, reportData, captchaValue } };
};

export const resetNewMeldooWebReportResponse = () => {
	return { type: RESET_SEND_NEW_MELDOO_WEB_REPORT_RESPONSE };
};

export const getMeldooWebTypesByLocation = selectedPosition => {
	return { type: SERVER_GET_MELDOO_WEB_TYPES_BY_LOCATION, payload: { selectedPosition } };
};

export const getMeldooWebTypesByOrganisationkey = organisationKey => {
	return { type: SERVER_GET_MELDOO_WEB_TYPES_BY_ORGANISATIONKEY, payload: { organisationKey } };
};



// WEBPACK FOOTER //
// ./actions/MeldooWeb.js